export const FISH_FILTER_TERM_ORDER = Object.freeze([
  "favourite",
  "missing",
  "missing-titles",
  "red",
  "yellow",
  "blue",
  "green",
  "white",
]);

export const SEARCH_EXPRESSION_RESERVED_KEYWORDS = Object.freeze([
  "and",
  "or",
  "not",
  "fish",
  "title",
  "item",
  "items",
  "npc",
  "trader",
  "imperial",
  "barter",
  "zone",
  "rod",
  "semantic",
  "fact",
  "filter",
  "from",
  "to",
  "before",
  "after",
  "patch",
  "status",
  "grade",
  "region",
  "regions",
  "regiongroup",
  "regiongroups",
  "region_group",
  "region_groups",
]);

const SEARCH_EXPRESSION_RESERVED_KEYWORD_PREFIX_SET = new Set(
  SEARCH_EXPRESSION_RESERVED_KEYWORDS.flatMap((keyword) =>
    Array.from({ length: keyword.length }, (_, index) => keyword.slice(0, index + 1))
  ),
);

export function isSearchExpressionReservedKeywordPrefix(value) {
  const normalized = String(value ?? "").trim().toLowerCase().replace(/-/g, "_");
  return SEARCH_EXPRESSION_RESERVED_KEYWORD_PREFIX_SET.has(normalized);
}

export const DEFAULT_SEARCH_EXPRESSION_OPERATOR = "or";
export const EMPTY_SEARCH_EXPRESSION = Object.freeze({
  type: "group",
  operator: DEFAULT_SEARCH_EXPRESSION_OPERATOR,
  children: Object.freeze([]),
});

export const MAP_SEARCH_LAYER_SUPPORT = Object.freeze({
  bookmarks: Object.freeze({
    termKinds: Object.freeze([]),
    attachmentClipModes: Object.freeze([]),
  }),
  fish_evidence: Object.freeze({
    termKinds: Object.freeze(["fish", "status", "grade", "item", "item-group", "title", "fishing-contest", "zone"]),
    attachmentClipModes: Object.freeze(["zone-membership"]),
  }),
  hotspots: Object.freeze({
    termKinds: Object.freeze(["fish", "status", "grade", "item", "item-group", "title", "fishing-contest"]),
    attachmentClipModes: Object.freeze([]),
  }),
  minimap: Object.freeze({
    termKinds: Object.freeze([]),
    attachmentClipModes: Object.freeze(["mask-sample"]),
  }),
  node_waypoints: Object.freeze({
    termKinds: Object.freeze([]),
    attachmentClipModes: Object.freeze([]),
  }),
  region_groups: Object.freeze({
    termKinds: Object.freeze(["semantic"]),
    attachmentClipModes: Object.freeze(["mask-sample"]),
  }),
  regions: Object.freeze({
    termKinds: Object.freeze(["semantic"]),
    attachmentClipModes: Object.freeze(["mask-sample"]),
  }),
  zone_mask: Object.freeze({
    termKinds: Object.freeze(["fish", "status", "grade", "item", "item-group", "title", "fishing-contest", "zone"]),
    attachmentClipModes: Object.freeze(["mask-sample"]),
  }),
});
